import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3b3a5ff4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "admin-card"
};
var _hoisted_2 = {
  class: "admin-description"
};
var _hoisted_3 = {
  class: "article-info-container"
};
var _hoisted_4 = {
  class: "article-info"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "文章", -1);
});

var _hoisted_6 = {
  class: "article-info"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "分类", -1);
});

var _hoisted_8 = {
  class: "article-info"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "标签", -1);
});

var _hoisted_10 = /*#__PURE__*/_createTextVNode("Follow Me");

var _hoisted_11 = {
  class: "social-icon-container"
};
var _hoisted_12 = {
  href: ""
};
var _hoisted_13 = ["href"];
var _hoisted_14 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_avatar = _resolveComponent("el-avatar");

  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_avatar, {
    size: 50,
    src: $setup.adminInfo.avatar,
    class: "avatar"
  }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("h3", null, _toDisplayString($setup.adminInfo.nickName), 1), _createElementVNode("p", null, _toDisplayString($setup.adminInfo.signature), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("p", null, _toDisplayString($setup.articleCountInfo.article), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("p", null, _toDisplayString($setup.articleCountInfo.category), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("p", null, _toDisplayString($setup.articleCountInfo.tag), 1)])]), _createVNode(_component_el_button, {
    type: "primary",
    class: "follow-button",
    onClick: $setup.gotoGithub
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: ['fab', 'github'],
        class: "github-icon"
      }), _hoisted_10];
    }),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_11, [_createElementVNode("a", _hoisted_12, [_createVNode(_component_font_awesome_icon, {
    icon: ['fab', 'twitter'],
    class: "social-icon",
    id: "twitter"
  })]), _createElementVNode("a", {
    href: $setup.adminInfo.githubUrl
  }, [_createVNode(_component_font_awesome_icon, {
    icon: ['fab', 'github'],
    class: "social-icon",
    id: "github"
  })], 8, _hoisted_13), _createVNode(_component_font_awesome_icon, {
    icon: ['fab', 'qq'],
    class: "social-icon",
    id: "qq"
  }), _createElementVNode("a", {
    href: 'mailto:' + $setup.adminInfo.email
  }, [_createVNode(_component_font_awesome_icon, {
    icon: ['fas', 'envelope'],
    class: "social-icon",
    id: "email"
  })], 8, _hoisted_14)])]);
}